import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spin } from "antd";
import constants from "../constants/constants";

export default function HotspotRedirect({ type }) {
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${constants.ApiUrl}/get-hotspot-details/${id}`)
            .then(res => res.json())
            .then(res => {
                if (res.code !== 200 || !res.data) {
                    throw new Error("Hotspot not found");
                }

                const data = res.data;

                const url =
                    type === "location"
                        ? data.location_url
                        : data.qr_code;

                if (!url) {
                    throw new Error("Redirect URL missing");
                }

                window.location.replace(url);
            })
            .catch(err => {
                console.error(err);
                navigate("*");
            });
    }, [id, type, navigate]);

    return <Spin fullscreen tip="Redirecting..." />;
}